import { useParams, useLocation } from 'react-router-dom';
import { useMemo } from 'react';

import BannerBestExecutionDettaglio from '../../../../../components/report/listaDriverPage/best-execution/best-execution-dettaglio/BannerBestExecutionDettaglio';
import ContainerBestExecutionDettaglio from '../../../../../components/report/listaDriverPage/best-execution/best-execution-dettaglio/ContainerBestExecutionDettaglio';

import { useElementDettaglio } from '../../../../../api/hooks/useReadElementDettaglio';
import { useSources } from '../../../../../api/hooks/useSources';
import { useReport } from '../../../../../api/hooks/useReport';
import { useEventsSearch } from '../../../../../api/hooks/useEventsSearch';

const DettaglioBestExecutionPage = () => {
  const { driverRoute } = useParams<{ driverRoute: string }>();
  const location = useLocation();
  const { id, driverId, intermediarioId } = location.state || {};

  const { report, loading: loadingReport, error: errorReport } = useReport(id);
  const { elements, loading: loadingElements, error: errorElements } = useElementDettaglio(id, driverId);
  const { sources, loading: loadingSources, error: errorSources } = useSources(id, driverId, intermediarioId);

const element = elements.find((el) => el.id === intermediarioId) || null;

const isLoading = loadingReport || loadingElements || loadingSources;
const hasError = errorReport || errorElements || errorSources;

const payload = useMemo(() => ({
  report_id: id,
  element_id: intermediarioId,
}), [id, intermediarioId]);

const { events } = useEventsSearch(payload);


  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="w-20 h-20 border-[6px] border-gray-300 border-t-textPrimary rounded-full animate-spin" />
      </div>
    );
  }

  if (hasError || !report || !element) {
    return (
      <div className="p-6 text-center text-red-500">
        {errorReport || errorElements || errorSources || 'Errore sconosciuto nel caricamento dei dati.'}
      </div>
    );
  }

  return (
    <div className="flex flex-col bg-gray-50">
      <BannerBestExecutionDettaglio
        report={report}
        title={driverRoute!}
        intermediario={element}
        reportId={id}
        driverId={driverId}
      />
      <div className="px-8 lg:px-16 py-8">
        <ContainerBestExecutionDettaglio
          intermediario={element}
          title={driverRoute!}
          driverRoute={driverRoute!}
          id={id}
          driverId={driverId}
          intermediarioId={intermediarioId}
          sources={sources}
          events={events}
        />
      </div>
    </div>
  );
};

export default DettaglioBestExecutionPage;
